import { setHeaders } from '../../../atoms/auth/setHeaders';

/**
 * Function that activates by ajax the core WP reset password funcionality.
 */
export function forgotPassword() {
  const container = document.querySelector( '.js-forgot-password' );
  if ( !container ) {
    return;
  }

  const form = container.querySelector( '.m__forgot-password-form' );
  const confirmation = container.querySelector( '.reset-confirmation' );
  const loader = container.querySelector( '.loader' );
  const errorMessage = container.querySelector( '.validation_error' );
  const submessage = container.querySelector( '.modal-submessage' );
  const goBackButton = document.querySelector( '.m__forgot-password-go-back' );
  const url = form.dataset.url;
  // Regular expresion to search for the ID login_error
  const errorRegEx = /id="(login_error)"/i;
  let isBlocked = false;

  form.addEventListener( 'submit', onSubmit );

  goBackButton.addEventListener( 'click', resetForm );

  /**
   * When form submits send post data.
   *
  * @param {object} event the event object.
   */
  function onSubmit( event ) {
    event.preventDefault();
    if ( isBlocked ) {
      return;
    }

    loader.classList.add( 'active' );
    isBlocked = true;
    errorMessage.innerHTML = '';

    const options = {
      method: 'POST',
      body: new FormData( form ),
      headers: setHeaders(),
    };

    fetch( url, options )
      .then( ( response ) => response.text() )
      .then( ( data ) => {
        const error = errorRegEx.exec( data );
        if ( error ) {
          errorMessage.innerHTML = 'There is no user registered with that email address';
          errorMessage.classList.remove( 'visuallyhidden' );
        } else {
          confirmation.classList.remove( 'visuallyhidden' );
          form.classList.add( 'visuallyhidden' );
          submessage.classList.add( 'visuallyhidden' );
        }
        clear();
      })
      .catch( clear );
  }

  /**
   * Clear sending process.
   */
  function clear() {
    isBlocked = false;
    loader.classList.remove( 'active' );
  }

  /**
   * Shows form and submessage and hides confirmation and error messages.
   */
  function resetForm() {
    form.classList.remove( 'visuallyhidden' );
    submessage.classList.remove( 'visuallyhidden' );
    confirmation.classList.add( 'visuallyhidden' );
    errorMessage.classList.add( 'visuallyhidden' );
  }
}
